import React from 'react';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { Dropdown, NavLabel, Row, LabelHelper, SubnavButton } from '../styles';

import { MONTH_NAMES } from 'utils/date';
import { getYearByDate, getMonthByDate } from '../utils';
import { later } from 'TaxonomyMapper/utils';

export class YearsSelect extends React.Component {
	state = {
		open: false,
	};

	handleChangeOpen = open => {
		this.setState({ open });
	};

	handleChange = (dateRangeId, dateFrom, dateTo) => {
		const { setQueryStringStateAndPush } = this.props;
		setQueryStringStateAndPush({
			dateRangeId,
			dateFrom,
			dateTo,
		});
		this.setState({ open: false });
	};

	redirectToDefaultRange = async () => {
		const { data } = this.props;

		if (data.length === 0) {
			return;
		}

		await later(1);

		const { id, dateFrom, dateTo } = data[data.length - 1];

		this.handleChange(id, dateFrom, dateTo);
	};

	render() {
		const { data, dateRangeId, disabled } = this.props;
		const { open } = this.state;
		let selectedRange = data.find(item => item.id.toString() === dateRangeId);

		if (!selectedRange) {
			selectedRange = {};
			this.redirectToDefaultRange();
		}

		return (
			<Dropdown
				label={selectedRange.name}
				hideOpenLabel
				open={open}
				onChangeOpen={this.handleChangeOpen}
				disabled={disabled}
			>
				{data.map(({ name, year, id, dateFrom, dateTo }) => (
					<SubnavButton
						key={id}
						title={name}
						onClick={() => this.handleChange(id, dateFrom, dateTo)}
					>
						<Row>
							<NavLabel active={id.toString() === dateRangeId}>{name}</NavLabel>
							<LabelHelper active={id.toString() === dateRangeId}>
								{!year
									? `${MONTH_NAMES[getMonthByDate(dateFrom)]}${getYearByDate(
											dateFrom
									  ).slice(-2)} - ${
											MONTH_NAMES[getMonthByDate(dateTo)]
									  }${getYearByDate(dateTo).slice(-2)}`
									: getMonthByDate(dateTo) - getMonthByDate(dateFrom) === 11
										? 'Full Year'
										: `${MONTH_NAMES[getMonthByDate(dateFrom)]} - ${
												MONTH_NAMES[getMonthByDate(dateTo)]
										  }`}
							</LabelHelper>
						</Row>
					</SubnavButton>
				))}
			</Dropdown>
		);
	}
}

export default props => (
	<SettingsOptionsContext.Consumer>
		{({ options }) => (
			<QueryStringContext.Consumer>
				{({ dateRangeId, setQueryStringStateAndPush }) => (
					<YearsSelect
						{...props}
						data={options ? options.dateRanges : []}
						dateRangeId={dateRangeId}
						setQueryStringStateAndPush={setQueryStringStateAndPush}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</SettingsOptionsContext.Consumer>
);
